<template>
	<div class="home">
		<div class="container">
			<el-tabs v-model="activeName" :stretch="true">
				<el-tab-pane label="证件号绑定" name="1">
					<bindCertificate></bindCertificate>
				</el-tab-pane>
				<el-tab-pane label="手机号绑定" name="2">
					<bindPhone></bindPhone>
				</el-tab-pane>
				<el-tab-pane label="邮箱绑定" name="3">
					<bindEmail></bindEmail>
				</el-tab-pane>
				<el-tab-pane label="安全问题" name="4">
					<safeQuestion></safeQuestion>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
import bindCertificate from "./components/bindCertificate";
import bindPhone from "./components/bindPhone";
import bindEmail from "./components/bindEmail";
import safeQuestion from "./components/safeQuestion";
export default {
	name: "home",
	data() {
		return {
			activeName: "1"
		};
	},
	components: {
		bindCertificate,
		bindPhone,
		bindEmail,
		safeQuestion
	},
	mounted() {
		const _this = this;
		this.$alert("此功能暂未开启", "提示", {
			confirmButtonText: "确定",
			callback: action => {
				_this.$router.go(-1);
			}
		});
	}
};
</script>